import GoogleAnalytics from "react-ga4";

const hostname = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
const isStaging = hostname.includes("staging");

// Only track production traffic.
if (!isLocal && !isStaging) {
  GoogleAnalytics.initialize("G-ZFTESG8LCY");
}

export default GoogleAnalytics;

